var map = {
	"./Account.json": "3301",
	"./Auth.json": "bc88",
	"./Booking.json": "b6a2",
	"./BossUsers.json": "da9a",
	"./Localize.json": "e629",
	"./Manage.json": "53ae",
	"./Review.json": "2fb3",
	"./Settings.json": "339b",
	"./SideBar.json": "1e3d",
	"./Users copy.json": "1710",
	"./Users.json": "cb30",
	"./meta.json": "936a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6cf6";